import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { play, pause, updateTime, setLoading } from "../store/actions/audio";

class Audio extends React.PureComponent {
  componentDidMount() {
    window.audioPlayer = this.audio;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.audio.playing !== this.props.audio.playing) {
      this.audio[nextProps.audio.playing ? 'play' : 'pause']();
    }
  }
  handleTimeUpdate = e => {
    const currentTime = e.target.currentTime;
    if (Math.abs(this.props.audio.time - currentTime) >= 1) {
      this.props.updateTime(e.target.currentTime);
    }
  }
  setLoading = () => {
    this.props.setLoading(false)
  }
  render() {
    const { audio } = this.props;
    return (
      <audio
        ref={node => this.audio = node}
        src={audio.src}
        autoPlay
        onTimeUpdate={this.handleTimeUpdate}
        onPlay={() => this.setLoading(true)}
        onEnded={this.props.pause}
      />
    )
  }
}

export default connect(
  state => (
    {
      audio: state.audio
    }
  ),
  dispatch => bindActionCreators({
    updateTime,
    play,
    pause,
    setLoading
  }, dispatch)
)(Audio)